<template>
  <div class="single">
    <HeroSingle :content="content.hero"></HeroSingle>

    <div class="wrapper">
      <div class="single-inner">
        <div
          v-for="(cpt, index) in content.flexibleContent"
          :key="`fl-${index}`"
          :class="`cpt-` + cpt.component"
        >
          <component
            :is="components[cpt.component]"
            v-if="cpt.component && components[cpt.component]"
            :content="cpt.content"
          />
          <pre v-else>coming soon: {{ cpt.component }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FlexibleAppointmentCta from '@/components/flexible/AppointmentCta.vue'
import FlexibleFaq from '@/components/flexible/Faq.vue'
import FlexibleSubCategories from '@/components/flexible/SubCategories.vue'
import FlexibleText from '@/components/flexible/Text.vue'
import FlexibleVideo from '@/components/flexible/Video.vue'
import HeroSingle from '@/components/hero/Single.vue'

import type { Component } from 'vue'

// Props
defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const components: Record<string, Component> = {
  wysiwyg: FlexibleText,
  video: FlexibleVideo,
  highlightedSubcategories: FlexibleSubCategories,
  appointmentCta: FlexibleAppointmentCta,
  faq: FlexibleFaq,
}
</script>

<style lang="scss" scoped>
.single {
  // prettier-ignore
  @include fluid(padding-top, (xxs: 6rem, xxl: 12rem));

  :deep(.hero-single__picture) {
    @include mq($until: s) {
      aspect-ratio: 1;
    }
  }

  :deep(.appointment__cta) {
    display: none;
  }
}

.single-inner {
  max-width: 80rem;
  margin: auto;
}
</style>
